/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from '@irian-ro/abstract-resource';
import {TaskDtoModel} from "./task-dto.model";
import { RouteDtoModel } from '@well/route-management/domain';

export class TaskListWithRouteDTO extends JSONable {

  routeDTO: RouteDtoModel | null = null;
  taskDTOs: TaskDtoModel[] = [];

}
